import LayoutNarrative from "components/layouts/LayoutNarrative";
import Meta from "solar/components/Meta";
import Button from "solar/components/Button";
import Break from "solar/components/Break";
import Photo from "components/narrative/Photo";
import Title from "components/narrative/Title";
import Lead from "components/narrative/Lead";
import Hero from "components/narrative/Hero";
import Body from "components/narrative/Body";
import Section from "components/narrative/Section";
import Prompt from "components/narrative/Prompt";

export default function Become() {
  const promptPhoto = (
    <Photo
      src="/become/join-us.jpg"
      alt="Become a guide"
      layout="fill"
      objectFit="cover"
    />
  );

  const promptAction = (
    <a
      href="mailto:guide@thermal.travel?subject=I'm interesting in becoming a guide"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button variant="off-white">Get in touch</Button>
    </a>
  );

  const promptTitle = (
    <Title size={4} font="cushing">
      Share your passion for
      <Break />
      surfing with the world.
    </Title>
  );

  return (
    <>
      <Meta
        title="Become a guide"
        description="We're constantly on the lookout for new additions to welcome into the fold. If you and your business would like to be considered, please get in touch."
        path="/become-a-guide"
        imageOgUrl="https://www.thermal.travel/meta/become-og.jpg"
        imageTwitterUrl="https://www.thermal.travel/meta/become-twitter.jpg"
        imageType="image/jpeg"
      />
      <Hero>
        <Photo
          src="/become/hero.jpg"
          alt="Become a guide"
          layout="fill"
          objectFit="cover"
          priority
        />
      </Hero>
      <Body>
        <Section>
          <Title tag="h1" size={2} font="cushing">
            Become a guide
          </Title>
          <Lead>
            Thermal proudly offers some of the most incredible surf trips in the
            world. Our community of guides share a passion for creating unique,
            authentic experiences that challenge the norms of surf travel. With
            a healthy respect for the environment and local communities, our
            guides set a high bar. We&apos;re constantly on the lookout for new
            additions to welcome into the fold. If you and your business would
            like to be considered, please get in touch.
          </Lead>
        </Section>
        <Section>
          <Title tag="h2" size={4} font="Windsor">
            Why join Thermal?
          </Title>
          <Lead>
            We provide access to a passionate community of surfers with an
            insatiable curiosity for the world, and we do our best to shed light
            on the incredible people and stories behind the trips we offer. Many
            guides choose to list their trips exclusively on Thermal because of
            our shared values and the emphasis we place on lasting, personal
            relationships. We&apos;re always happy to hear from our guides, no
            matter the concern, and we’re constantly looking for new ways to
            help their businesses thrive.
          </Lead>
        </Section>
      </Body>
      <Prompt photo={promptPhoto} title={promptTitle} action={promptAction} />
    </>
  );
}

Become.Layout = LayoutNarrative;
